import React from 'react';
import "./Scheme.css";

const Input = ({id, label, placeholder, onChange, value, type, maxLength, isReadOnly, inputMode, accept, error, validation, validation2 } )=> {

  return (
    <div className="mb-3">
        <label  className="form-label">{label}</label><br/>
        {accept=="application/pdf" && <><small className='pdf-text'>Upload File (PDF only)</small><br/></> }
        {accept==".jpg, .jpeg, .png" && <><small className='pdf-text'>Upload File (PNG, JPEG)</small><br/></> }
        <input className="form-control no-spinner" type={type} accept={accept} id={id} onChange={onChange} maxLength={maxLength} placeholder={placeholder} inputMode={inputMode} value={value} readOnly={isReadOnly} style={{ backgroundColor: isReadOnly?'#F5F5F5':''  }}/>
        {error && <><small className='error-text'>{error}</small><br/></>}
        {validation && <><small className='validation-text'>{validation}</small><br/></>}
        <small className='validation-text'>{validation2}</small>
    </div>
  )
}

export default Input;